import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { AppBarWithButtons } from '../../../../components/designe/app-bars/app-bar-with-action-buttons/AppBarWithButtons';
import AppProgramCollectionAvatar from '../../../../components/designe/app-entity-avatar/app-program-collection-avatar/AppProgramCollectionAvatar';
import AppSelectWrapper from '../../../../components/designe/textfields/app-select-wrapper/AppSelectWrapper';
import AppTextField from '../../../../components/designe/textfields/app-text-field/AppTextField';
import { useGetUserProgramCollections } from '../../../../redux/api/programsAPI';
import { AvatarSize, AvatarTypes } from '../../../../shared/constants';
import { IProgramCollection } from '../../../../types/interfaces/program-collection';
import { ITraining } from '../../../../types/interfaces/training';
import { useStyles } from './CreateProgramFromTraining.styles';

interface ICreateProgramFromTrainingProps {
  training: ITraining;
  onCancel: () => void;
  onCreateProgram: (title: string, collectionId?: string) => Promise<any>;
}

export default function CreateProgramFromTraining(
  props: ICreateProgramFromTrainingProps,
) {
  const { onCancel, onCreateProgram, training } = props;
  const [loader, setLoader] = useState<boolean>(false);
  const [selectedCollection, setSelectedCollection] = useState(null);
  const [title, setTitle] = useState('');
  const { data: collections } = useGetUserProgramCollections();
  const { t } = useTranslation();
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const placeholder = training?.title
    ? `${training.title}`
    : t('programs.newProgramItem');

  return (
    <Box className={classes.createProgramWrapper}>
      <Box display="flex" flexDirection="column" gap={1}>
        <AppTextField
          label={t('common.title')}
          fullWidth
          value={title}
          placeholder={placeholder}
          onChange={(e) => setTitle(e.target.value)}
        />
        <AppSelectWrapper
          label={t('programs.programCollection')}
          fieldName={'title'}
          options={collections}
          defaultValue={selectedCollection}
          onChange={(e) => {
            setSelectedCollection(e?.target?.value || null);
          }}
          className={classes.selectorWithContent}
          renderOption={(programCollection: IProgramCollection) => (
            <Box className={classes.collectionWrapper}>
              <AppProgramCollectionAvatar
                programCollection={programCollection}
                size={AvatarSize.s}
                type={AvatarTypes.round}
              />
              <div>{programCollection.title}</div>
            </Box>
          )}></AppSelectWrapper>
      </Box>

      <Box className={classes.createProgramBottom}>
        <AppBarWithButtons
          loading={loader}
          onClick={() => {
            setLoader(true);
            onCreateProgram(
              title || placeholder,
              selectedCollection?.id,
            ).finally(() => {
              setLoader(false);
            });
          }}
          onCancelClick={onCancel}
        />
      </Box>
    </Box>
  );
}
